import React, { useEffect, useRef, useState } from 'react'
import '../Style/Index.css'
import '../Style/Signup.css'
import User from '../Logos/user.svg'
import Lock from '../Logos/lock (1).svg'
import { Link } from 'react-router-dom'
import axios from 'axios'

function Signup(props) {

    const [Email, SetEmail] = useState()

    const phonenuminput = useRef()
    const phonenumtitle = useRef()

    useEffect(() => {
        phonenuminput.current.addEventListener("focus", () => {
            phonenumtitle.current.style.transform = "translateY(-20px)"
            phonenumtitle.current.style.fontSize = "12px"
            phonenumtitle.current.style.color = "black"

        });
        phonenuminput.current.addEventListener("focusout", () => {
            if (!phonenuminput.current.value.length > 0) {
                phonenumtitle.current.style.transform = "translateY(0px)"
                phonenumtitle.current.style.fontSize = "15px"
                phonenumtitle.current.style.color = "#a7a7a7";
            }

        });

    }, []);


    const handle_Signup = (e) => {
        e.preventDefault()
        if (Email && Email === "") {
            return
        } else {
            axios.post("http://127.0.0.1:3001/send-code", { Email })
                .then(data => {
                    if (data.data) {
                        console.log(data.data)
                    } else {
                        return
                    }
                })
                .catch(err => { console.log(err) })
        }
    }

    return (
        <>
            <form onSubmit={(e) => handle_Signup(e)} className='Signup-section-contianer'>
                <div className='title'>ثبت نام</div>
                <div className='description'>با استفاده از شماره موبایل خود به راحتی حساب کاربریتان را ایجاد کنید</div>
                <div className='inputs-container'>
                    <div className='phone-num-input-container'>
                        <img src={User} className='user-icon' />
                        <div className='title' ref={phonenumtitle}>شماره موبایل بدون 0</div>
                        <input type='text' ref={phonenuminput} name='phonenumber' onChange={(e) => { SetEmail(e.target.value) }} />
                    </div>
                </div>
                <button type='submit' className='Signup-button'>ثبت نام</button>
                <div className='change-to-login' onClick={() => { props.OnFormSwitch() }}>ورود به حساب کاربری</div>
            </form>
        </>
    )
}

export default Signup